export enum FeatureFlagNames {
    checkin_v4 = 'checkin_v4',
    invoicing_settlement = 'invoicing_settlement',
    unpaid_bills = "unpaid_bills",
    use_new_invoice_template = "use_new_invoice_template",
    use_new_invoice_template_for_etomotors = "use_new_invoice_template_for_etomotors",

    // app
    show_games_in_profile = 'show_games_in_profile',
    show_games_in_charging_process = 'show_games_in_charging_process',
    my_rfids = 'my_rfids',
    fastag_wallet = 'fastag_wallet',
    paytm_wallet = 'paytm_wallet',
    pulse_wallet = 'pulse_wallet',
    discounts = 'discounts',
    discounts_for_reservations = 'discounts_for_reservations',
    vrn_capturing = 'vrn_capturing',
    soc_capturing = 'soc_capturing',
    odo_capturing = 'odo_capturing',

    vrn_ocr = 'vrn_ocr',
    soc_ocr = 'soc_ocr',
    odo_ocr = 'odo_ocr',
    
    invoice_receipt_download_btns = 'invoice_receipt_download_btns',
    /**
     * Not used after v2.0.2
     */
    submit_cash_payment_via_link = 'submit_cash_payment_via_link',
    submit_cash_payment_via_sdk = 'submit_cash_payment_via_sdk',

    /**
     * @deprecated
     */
    pending_bills = 'pending_bills',
    use_new_issue_link = 'use_new_issue_link',
    fetch_payment_gateway_config = 'fetch_payment_gateway_config',
    iod = "iod",
    book_charger = 'book_charger',
    wallet_inflow_settlement = "wallet_inflow_settlement",
    use_new_entity_count_api = "use_new_entity_count_api",

    new_cs_detail_screen = "new_cs_detail_screen",
    new_v3_endpoints = "new_v3_endpoints",
    use_new_find_route_logic = "use_new_find_route_logic",

    vehicle_selection = "vehicle_selection",

    /**
     * Determines if the Force logout feature should be enabled for a user or not
     * 
     * @todo To be removed once users of all apps are migrated to higher version than v2.0.4
     */

    force_logout_on_backend = "force_logout_on_backend",
    /**
     * Determines if we should mail regarding issue ticket assignment to assignee or not
     */
    should_send_mail_to_issue_ticket_assignee = "should_send_mail_to_issue_ticket_assignee",

    energy_graph = "energy_graph",
    live_demand_graph = 'live_demand_graph',
    
    otm = "otm",

    /**
     * Determines if the Flat fee tariff should be shown for the fleet or not
     */
    tariff_wallet_fraud_prevention = "tariff_wallet_fraud_prevention",

    cs_ocpi_setup='cs_ocpi_setup',

    /**
     * Can be used to disable supervisor approval requests for everest
     */
    disable_supervisor_pending_check_ins = 'disable_supervisor_pending_check_ins',

    /**
     * Can be used to enable the fast charging session limit
     */
    fast_charging_session_limit_enabled = 'fast_charging_session_limit_enabled',

    /**
     * Can be used to enable OCR for everest
     */
    everest_check_in_ocr = 'everest_check_in_ocr',

    /**
     * Can be used to disable editing of odo and soc for everest drivers
     */
    should_disable_odo_and_soc_edit = 'should_disable_odo_and_soc_edit',
}

export enum Client {
    Console = 'console',
}

export enum PlatformEnum {
    android = 'android',
    ios = 'ios',
}
